import { useTranslation } from "react-i18next";
import { AppLink } from "@/components/ui";
import { Layers } from "lucide-react";

/**
 * Landing page footer — branding, tagline, links, copyright.
 * Rosé Pine Dawn luxury aesthetic.
 */
export function LandingFooter() {
  const { t } = useTranslation();

  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-24 px-6 border-t border-border bg-surface/80" role="contentinfo">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-20 text-center md:text-left">
        <div className="space-y-8">
          <div className="flex items-center gap-3 justify-center md:justify-start">
            <div className="w-10 h-10 bg-success rounded-xl flex items-center justify-center">
              <Layers className="text-background w-6 h-6" />
            </div>
            <span className="font-bold text-2xl tracking-tight text-foreground">
              Neural AI
            </span>
          </div>
          <p className="text-foreground-muted text-sm max-w-sm leading-relaxed mx-auto md:mx-0">
            {t("landing.footer.tagline")}
          </p>
        </div>

        <nav
          aria-label="Footer links"
          className="flex flex-wrap justify-center md:justify-end gap-16 text-[10px] font-black uppercase tracking-[0.3em] text-foreground-muted"
        >
          <AppLink href="#" className="hover:text-foreground transition-colors text-inherit no-underline">
            {t("landing.footer.links.privacy")}
          </AppLink>
          <AppLink href="#" className="hover:text-foreground transition-colors text-inherit no-underline">
            {t("landing.footer.links.security")}
          </AppLink>
          <AppLink href="#" className="hover:text-foreground transition-colors text-inherit no-underline">
            {t("landing.footer.links.status")}
          </AppLink>
        </nav>
      </div>

      <div className="max-w-7xl mx-auto mt-24 pt-12 border-t border-border flex flex-col md:flex-row justify-between items-center opacity-40">
        <span className="text-[10px] font-mono tracking-[0.5em] uppercase text-foreground">
          {t("landing.footer.designNote")}
        </span>
        <span className="text-[10px] font-mono mt-4 md:mt-0 uppercase tracking-widest text-foreground">
          {t("landing.footer.copyright", { year: currentYear })}
        </span>
      </div>
    </footer>
  );
}
